import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from 'react-router';

import { GoogleIcon } from '@app-velocity/icons';

import { Button } from '@app-velocity/ui';

import { AuthRoutesPaths } from '@app-velocity/libs/auth';

import { useAuthProviderContext } from '../../../../context/useAuthProviderContext';

export const GoogleSignInButton = () => {
  const navigate = useNavigate();
  const { type: authType, setProviderType } = useAuthProviderContext();
  const [searchParams] = useSearchParams();

  const goToGoogleAuth = () => {
    const originalUrl = searchParams.get('originalUrl');

    if (authType === 'detached') {
      setProviderType('google');

      return;
    }

    navigate({
      pathname: AuthRoutesPaths.GoogleAuth,
      search: originalUrl ? createSearchParams({ originalUrl }).toString() : '',
    });
  };

  return (
    <Button
      fullWidth
      type="button"
      variant="contained"
      size="large"
      color="secondary"
      data-testid="form-login-google"
      data-ph-capture-attribute-id="google_auth_button"
      onClick={goToGoogleAuth}
    >
      <GoogleIcon /> Google
    </Button>
  );
};
